<template>
  <div class="hidden md:block">
    <h2 class=" text-left	 mb-25 font-semibold text-skin-secondary text-l ">
      Categorías
    </h2>
    <ul class="bg-skin-secondary rounded-xl p-35 mb-47  w-card_medium">
      <li
        class="mb-12px cursor-pointer border-l-4 border-red-400 pl-12px text-skin-secondary"
        v-for="(option, index) in categories"
        :key="index"
        @click="
          clickcategory(option.id);
          getname(option.name);
          getCategory(option);
        "
      >
        {{ option.name }}
      </li>
      <li
        v-if="freebies"
        @click="$emit('free')"
        class="mb-12px cursor-pointer border-l-4 border-red-400 pl-12px text-skin-secondary"
      >
        Gratuitos
      </li>
      <li
        @click="$emit('seeall')"
        class="mb-12px cursor-pointer border-l-4 border-red-400 pl-12px text-skin-secondary"
      >
        Ver todos
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    categories: {
      required: true,
    },
    freebies: {
      type: Boolean,
      default: false,
    },
    outSide: {
      default: false,
    },
  },
  methods: {
    clickcategory(id) {
      this.$emit("clicked", id);
    },
    getname(name) {
      this.$emit("category_name", name);
    },
    getCategory(option){
      this.$emit("categorySelect", option);
    }
  },
};
</script>
